import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'

import { clientsInfiniteQueryOptions } from '@/hooks'
import {
  ALL_CLIENT_STATUSES,
  buildClientsQueryOptions,
  ClientsPage,
} from '@/pages/clients/ClientsPage'

const ClientsSearchSchema = z.object({
  status: z.enum(ALL_CLIENT_STATUSES).optional(),
})

export const Route = createFileRoute('/_authenticated/_dashboard/clients/')({
  validateSearch: ClientsSearchSchema,
  loaderDeps: ({ search }) => ({ search }),
  loader: ({ context, deps }) =>
    context.queryClient.ensureInfiniteQueryData(
      clientsInfiniteQueryOptions(buildClientsQueryOptions(deps.search)),
    ),
  component: ClientsPage,
})
